<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css" />

<style>
  /* Mockup specific CSS styles */
  .dropdown {
    display: none;
    position: absolute;
    right: 0;
    top: 100%;
    margin-top: 0.5rem;
  }

  /* Spacer to bridge the hover gap between button and dropdown list */
  .dropdown::before {
    content: '';
    position: absolute;
    top: -1.5rem;
    left: 0;
    right: 0;
    height: 1.5rem;
    background: transparent;
  }

  .group:hover .dropdown {
    display: block;
  }

  .dropdown-flex {
    display: none;
  }

  .group:hover .dropdown-flex {
    display: flex !important;
  }

  .modal {
    display: none;
    position: fixed;
    inset: 0;
    z-index: 1999;
    background-color: rgba(15, 23, 42, 0.6);
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }

  .modal.show {
    display: flex;
  }

  /* Layout helpers */
  .relative {
    position: relative;
  }

  .absolute {
    position: absolute;
  }

  .z-50 {
    z-index: 1050;
  }

  .right-0 {
    right: 0;
  }

  /* Flex classes */
  .flex {
    display: flex;
  }

  .items-center {
    align-items: center;
  }

  .justify-center {
    justify-content: center;
  }

  .gap-1.5 {
    gap: 0.375rem;
  }

  .gap-2 {
    gap: 0.5rem !important;
  }

  .gap-3 {
    gap: 0.75rem !important;
  }

  .grid {
    display: grid !important;
  }

  .grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }

  /* Sizing and shapes */
  .w-9 {
    width: 2.25rem;
  }

  .h-9 {
    height: 2.25rem;
  }

  /* Increased dropdown widths for better fit as requested */
  .w-56 {
    width: 16rem !important;
  }

  .w-60 {
    width: 18rem !important;
  }

  .w-64 {
    width: 20rem !important;
  }

  .w-72 {
    width: 22rem !important;
  }

  .w-80 {
    width: 28rem !important;
  }

  /* Wide quick action modal */

  .px-3 {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .p-2 {
    padding: 0.5rem !important;
  }

  .p-3 {
    padding: 0.75rem !important;
  }

  .rounded-xl {
    border-radius: 0.75rem;
  }

  .rounded-2xl {
    border-radius: 1rem;
  }

  /* Visual styling */
  .bg-white {
    background-color: #ffffff;
  }

  .bg-blue-50 {
    background-color: #eff6ff;
  }

  .bg-red-50 {
    background-color: #fef2f2;
  }

  .bg-green-50 {
    background-color: #f0fdf4;
  }

  .bg-emerald-50 {
    background-color: #ecfdf5;
  }

  .bg-amber-50 {
    background-color: #fffbeb;
  }

  .border {
    border: 1px solid #e2e8f0;
  }

  .border-slate-100 {
    border-color: #f1f5f9;
  }

  .text-slate-600 {
    color: #475569;
  }

  .text-slate-700 {
    color: #334155;
  }

  .text-slate-800 {
    color: #1e293b;
  }

  .text-blue-600 {
    color: #2563eb;
  }

  .text-red-600 {
    color: #dc2626;
  }

  .text-green-700 {
    color: #15803d;
  }

  .text-emerald-600 {
    color: #059669;
  }

  .text-amber-600 {
    color: #d97706;
  }

  .font-semibold {
    font-weight: bold !important;
  }

  .font-medium {
    font-weight: 500;
  }

  .shadow-xl {
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .cursor-pointer {
    cursor: pointer;
  }

  .block {
    display: block;
  }

  .text-left {
    text-align: left;
  }

  .text-xs {
    font-size: 0.75rem;
  }

  @media (max-width: 1200px) {
    .hidden {
      display: none !important;
    }
  }

  /* BUTTON & HOVER IMPROVEMENTS */
  .iam-topbar-actions button {
    border: none;
    background: transparent;
    outline: none;
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .utility-btn,
  .iam-topbar-actions .btn-eco,
  .iam-topbar-actions .btn-app,
  .iam-topbar-actions .btn-service,
  .iam-topbar-actions .btn-support,
  .iam-topbar-actions .btn-remote,
  .iam-topbar-actions .btn-quick {
    height: 2.25rem !important;
    /* h-9 */
    padding: 0 0.75rem !important;
    /* px-3 */
    border-radius: 0.75rem !important;
    /* rounded-xl */
    transition: all 0.15s ease-in-out !important;
    text-decoration: none !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    font-weight: 600 !important;
    box-sizing: border-box !important;
  }

  /* Default hover styling (Ecosystem, Help, Support) */
  .utility-btn,
  .btn-eco,
  .btn-support {
    color: #475569 !important;
    background-color: transparent !important;
    border: none !important;
  }

  .utility-btn:hover,
  .btn-eco:hover,
  .btn-support:hover {
    background-color: #eff6ff !important;
    /* hover:bg-blue-50 */
    color: #2563eb !important;
    /* hover:text-blue-600 */
  }

  /* App Switcher button sizing */
  .btn-eco {
    width: 2.25rem !important;
    padding: 0 !important;
  }

  /* Mobile App styles */
  .btn-app {
    color: #059669 !important;
    background-color: transparent !important;
    border: none !important;
  }

  .btn-app:hover {
    background-color: #ecfdf5 !important;
    /* hover:bg-emerald-50 */
    color: #059669 !important;
  }

  /* Dịch vụ (Services) styles */
  .btn-service {
    border: 1px solid #bfdbfe !important;
    /* border-blue-200 */
    background-color: #eff6ff !important;
    /* bg-blue-50 */
    color: #2563eb !important;
    /* text-blue-600 */
  }

  .btn-service:hover {
    background-color: #dbeafe !important;
    color: #2563eb !important;
  }

  /* Hỗ trợ từ xa styles */
  .btn-remote {
    border: 1px solid #bbf7d0 !important;
    /* border-green-200 */
    background-color: #f0fdf4 !important;
    /* bg-green-50 */
    color: #15803d !important;
    /* text-green-700 */
  }

  .btn-remote:hover {
    background-color: #dcfce7 !important;
    /* hover:bg-green-100 */
    color: #15803d !important;
  }

  /* Nhanh (Quick Create) styles */
  .btn-quick {
    background-color: #fffbeb !important;
    /* bg-amber-50 */
    color: #d97706 !important;
    /* text-amber-600 */
    border: none !important;
  }

  .btn-quick:hover {
    background-color: #fef3c7 !important;
    /* hover:bg-amber-100 */
    color: #d97706 !important;
  }

  /* Unified theme buttons styling matching mockup */
  .theme-btn-square {
    width: 2.75rem !important;
    height: 2.75rem !important;
    border-radius: 12px !important;
    border: 1px solid #e2e8f0 !important;
    background-color: #ffffff !important;
    box-shadow: 0 2px 8px rgba(0, 52, 185, 0.05) !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
    padding: 0 !important;
    position: relative !important;
  }

  .theme-btn-square:hover {
    border-color: #0054c2 !important;
    box-shadow: 0 4px 12px rgba(0, 84, 194, 0.15) !important;
    transform: translateY(-1px);
  }

  .theme-btn-square i {
    color: #0054c2 !important;
    font-size: 1.25rem !important;
  }

  .theme-btn-remote {
    height: 2.75rem !important;
    padding: 0 1.25rem !important;
    border-radius: 12px !important;
    border: 1px solid #bbf7d0 !important;
    background-color: #e6f9f0 !important;
    color: #00a854 !important;
    box-shadow: 0 2px 8px rgba(0, 168, 84, 0.05) !important;
    display: inline-flex !important;
    align-items: center !important;
    gap: 0.625rem !important;
    cursor: pointer !important;
    transition: all 0.2s ease !important;
    font-weight: 700 !important;
    font-size: 0.95rem !important;
    letter-spacing: 0.5px !important;
    text-transform: uppercase !important;
  }

  .theme-btn-remote:hover {
    background-color: #d3f9e8 !important;
    border-color: #00a854 !important;
    box-shadow: 0 4px 12px rgba(0, 168, 84, 0.15) !important;
    transform: translateY(-1px);
  }

  .theme-btn-remote i {
    color: #00a854 !important;
    font-size: 1.35rem !important;
  }

  /* Font-family synchronization with main project font */
  .iam-topbar,
  .dropdown,
  .modal,
  .utility-btn,
  .iam-topbar-actions,
  button,
  a,
  span,
  div {
    font-family: var(--font-family, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif) !important;
  }
</style>

<div class="iam-topbar">
  <div class="iam-topbar-left">
    <div class="p-pt-1 p-pl-3">
      <a routerLink="/personal-income-tax/dashboard" title="IAM">
        <img src="assets/iam/logos/iam-pit.png" alt="IAM Invoice" style="height: 4rem">
      </a>
    </div>
  </div>
  <div class="iam-topbar-right">
    <div class="iam-topbar-menu">
    </div>

    <ul class="iam-topbar-actions flex items-center gap-3"
      style="display: flex !important; flex-direction: row !important; align-items: center !important; list-style-type: none !important; padding-right: 1.5rem !important;">

      <!-- Hotline -->
      <li class="iam-topbar-action relative" style="margin-right: 0.5rem;" *ngIf="user?.supportNumber">
        <a pRipple class="flex items-center gap-2" (click)="entities.onTopbarActionClick($event, 'ShowSupport')"
          title="Hotline"
          style="text-decoration: none; color: #475569; font-size: 1rem; display: inline-flex !important; align-items: center; cursor: pointer;">
          <i class="fa-solid fa-phone-volume" style="color: #0054c2; font-size: 1.25rem;"></i>
          <span>Hotline: <b style="font-weight: bold; color: #0054c2; font-size: 1.1rem; margin-left: 2px;">{{
              user?.supportNumber }}</b></span>
        </a>
        <div *ngIf="entities.activeTopbarAction === 'ShowSupport'" class="iam-topbar-action-panel p-shadow-6 p-p-3"
          style="position: absolute; top: 100%; margin-top: 0.5rem; right: 0; z-index: 1000;">
          <div class="">
            <div class="p-col-12" style="border-bottom: 1px solid #1492e6;">
              <b style="line-height: 20px;display: inline-block;">Thông tin đại lý</b>
            </div>
            <div class="p-col-12 pointer">Mã đại lý: {{ user?.supportPseudoId }}</div>
            <div class="p-col-12 pointer">Tên đại lý: {{ user?.supportPartyName }}</div>
            <div class="p-col-12" style="border-top: 1px solid #1492e6;">
              <b style="line-height: 20px;display: inline-block;">Hotline công ty: {{ user?.hotlineOrganization }}</b>
            </div>
          </div>
        </div>
      </li>

      <!-- Zalo -->
      <li class="iam-topbar-action">
        <a href="https://zalo.me/3919081551375297120" target="_blank" rel="noopener noreferrer" title="Zalo CSKH"
          class="theme-btn-square" style="text-decoration: none;">
          <img src="assets/images/zalo-60x60.png" alt="Zalo CSKH"
            style="width: 1.75rem; height: 1.75rem; border-radius: 6px;">
        </a>
      </li>

      <!-- HỖ TRỢ TỪ XA (IAM Remote) -->
      <li class="iam-topbar-action">
        <button (click)="openRemoteSupport($event)" class="theme-btn-remote" title="HỖ TRỢ TỪ XA">
          <i class="fa-solid fa-desktop"></i>
          <span>HỖ TRỢ TỪ XA</span>
        </button>
      </li>

      <!-- Trợ giúp -->
      <li class="iam-topbar-action relative group">
        <button class="theme-btn-square" title="Trợ giúp">
          <i class="fa-regular fa-circle-question"></i>
        </button>
        <div class="dropdown bg-white rounded-2xl shadow-xl border border-slate-100 p-2 z-50 text-left w-72"
          style="padding: 1.25rem !important; right: 0; top: 100%; margin-top: 0.5rem;">
          <div class="font-semibold text-slate-800 px-2 pb-3"
            style="font-size: 1.25rem; font-weight: bold; border-bottom: 1px solid #f1f5f9; margin-bottom: 0.75rem;">Trợ
            giúp</div>

          <!-- Video HDSD -->
          <a href="https://www.youtube.com/playlist?list=PLbWnmeWz0cgsdvhlTatNowbMnKQTubmxG" target="_blank"
            rel="noopener noreferrer" class="flex items-center gap-3 p-3 rounded-xl hover:bg-blue-50"
            style="display: flex !important; align-items: center; text-decoration: none; color: inherit;">
            <div class="w-9 h-9 rounded-xl bg-red-50 text-red-600 flex items-center justify-center"
              style="width: 2.25rem; height: 2.25rem; border-radius: 0.75rem; display: flex !important; align-items: center; justify-content: center;">
              <i class="fa-brands fa-youtube" style="font-size: 1.25rem; color: #dc2626;"></i>
            </div>
            <div>
              <div class="font-semibold text-slate-800" style="font-weight: bold; font-size: 0.875rem;">Video hướng dẫn
                sử dụng</div>
              <div class="text-xs text-slate-500" style="margin-top: 2px;">Hướng dẫn lập, ký, gửi hóa đơn</div>
            </div>
          </a>

          <!-- Tài liệu HDSD -->
          <a href="https://honkit.iamsoftware.com.vn/IAMPIT/hdsd-iam-pit.html" target="_blank"
            class="flex items-center gap-3 p-3 rounded-xl hover:bg-blue-50"
            style="display: flex !important; align-items: center; text-decoration: none; color: inherit; margin-top: 0.25rem;">
            <div class="w-9 h-9 rounded-xl bg-blue-50 text-blue-600 flex items-center justify-center"
              style="width: 2.25rem; height: 2.25rem; border-radius: 0.75rem; display: flex !important; align-items: center; justify-content: center;">
              <i class="pi pi-file" style="font-size: 1.25rem; color: #3b82f6;"></i>
            </div>
            <div>
              <div class="font-semibold text-slate-800" style="font-weight: bold; font-size: 0.875rem;">Tài liệu HDSD
              </div>
              <div class="text-xs text-slate-500" style="margin-top: 2px;">Tài liệu hướng dẫn chi tiết</div>
            </div>
          </a>

          <!-- Tải app Android -->
          <a href="https://play.google.com/store/apps/details?id=com.etax.icanhan&hl=vi"
            (click)="openAppDownloadQr($event, 'android')"
            class="flex items-center gap-3 p-3 rounded-xl hover:bg-green-50"
            style="display: flex !important; align-items: center; text-decoration: none; color: inherit; margin-top: 0.25rem;">
            <div class="w-9 h-9 rounded-xl bg-green-50 text-green-600 flex items-center justify-center"
              style="width: 2.25rem; height: 2.25rem; border-radius: 0.75rem; display: flex !important; align-items: center; justify-content: center;">
              <i class="fa-brands fa-android" style="font-size: 1.25rem; color: #22c55e;"></i>
            </div>
            <div>
              <div class="font-semibold text-slate-800" style="font-weight: bold; font-size: 0.875rem;">Tải app Android
              </div>
              <div class="text-xs text-slate-500" style="margin-top: 2px;">Cài ứng dụng IAM Invoice trên Android</div>
            </div>
          </a>

          <!-- Tải app iOS -->
          <a href="https://apps.apple.com/vn/app/etax-mobile/id1589750682" (click)="openAppDownloadQr($event, 'ios')"
            class="flex items-center gap-3 p-3 rounded-xl hover:bg-slate-50"
            style="display: flex !important; align-items: center; text-decoration: none; color: inherit; margin-top: 0.25rem;">
            <div class="w-9 h-9 rounded-xl bg-slate-50 text-slate-800 flex items-center justify-center"
              style="width: 2.25rem; height: 2.25rem; border-radius: 0.75rem; display: flex !important; align-items: center; justify-content: center;">
              <i class="fa-brands fa-apple" style="font-size: 1.25rem; color: #1e293b;"></i>
            </div>
            <div>
              <div class="font-semibold text-slate-800" style="font-weight: bold; font-size: 0.875rem;">Tải app iOS
              </div>
              <div class="text-xs text-slate-500" style="margin-top: 2px;">Cài ứng dụng IAM Invoice trên iPhone/iPad
              </div>
            </div>
          </a>
        </div>
      </li>

      <!-- Chuyển ứng dụng (Ecosystem) -->
      <li class="iam-topbar-action relative group" *ngIf="AuthService.hasRoles(['Customer'])">
        <button class="theme-btn-square" title="Hệ sinh thái IAM">
          <i class="fa-solid fa-table-cells-large"></i>
        </button>
        <div class="dropdown dropdown-flex iam-topbar-action-panel p-shadow-6 p-p-3" style="position: absolute; top: 100%; margin-top: 0.5rem;
          right: 0; z-index: 1000;
          width: 120px !important; min-width: unset !important;
          height: 120px; padding: 1rem 0.5rem;
          border-radius: 12px; background-color: #ffffff;
          box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1);
          transform-origin: top right;
          align-items: center; justify-content: center; flex-direction: row;
        ">
          <a pRipple class="p-d-flex p-flex-column p-ai-center layout-topbar-action-item"
            href="https://invoice.iamsoftware.com.vn/" target="_blank"
            style="text-decoration: none; color: inherit;">
            <img src="assets/images/icon-hst-iam-invoice.png" alt="Hóa đơn" width="50" height="50"
              style="border-radius: 8px;">
            <span class="p-mt-2 p-text-bold"
              style="font-size: 12px; line-height: 1.2; text-align: center; color: #131315;">
              Hóa đơn
            </span>
          </a>
        </div>
      </li>

      <!-- Profile -->
      <li class="iam-topbar-action relative group">
        <button (click)="entities.onTopbarActionClick($event, 'Profile')"
          class="theme-btn-square flex items-center gap-2" title="Tài khoản"
          style="width: auto !important; padding: 0 0.875rem !important;">
          <i class="pi pi-user" style="font-size: 1.25rem;"></i>
          <span style="font-weight: bold; font-size: 0.875rem; color: #0054c2; margin-left: 2px;"
            *ngIf="user?.partyTaxId">{{ user.partyTaxId }}</span>
        </button>
        <ul *ngIf="entities.activeTopbarAction === 'Profile'" class="iam-topbar-action-panel p-shadow-6"
          style="position: absolute; top: 100%; margin-top: 0.5rem; right: 0; z-index: 1000; width: 15rem; background-color: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0; padding: 0.5rem 0;">
          <li class="topbar-menu-item">
            <a pRipple class="topbar-link" (click)="changePassword()">
              <i class="pi pi-unlock"></i>
              <span>{{ 'ChangePassword' | translate }}</span>
            </a>
          </li>
          <li class="topbar-menu-item">
            <a pRipple class="topbar-link logout" (click)="logout()">
              <i class="pi pi-power-off"></i>
              <span>{{ 'Logout' | translate }}</span>
            </a>
          </li>
          <li class="p-pt-2 p-pr-3 p-pl-3 p-pb-2 p-text-center"
            style="border-top: 1px solid #f1f5f9; padding-top: 0.5rem; margin-top: 0.5rem;" *ngIf="user?.partyName">
            <div
              style="font-weight: 700; font-size: 0.85rem; color: #1e293b; word-break: break-word; line-height: 1.4;">{{
              user.partyName }}</div>
            <div style="font-size: 0.75rem; color: #64748b; margin-top: 2px;" *ngIf="user.partyTaxId">MST: {{
              user.partyTaxId }}</div>
          </li>
        </ul>
      </li>

    </ul>
  </div>
</div>

<form [formGroup]="changePasswordForm" (ngSubmit)="onChangePassword()">
  <p-dialog header="{{ 'ChangePassword'|translate }}" [(visible)]="changingPassword" [style]="{width: '500px'}"
    [resizable]="false" position="top">
    <p-message severity="info"
      text="Xin quý khách lưu ý, để đảm bảo an ninh tài khoản nên dùng một mật khẩu đầy đủ yếu tố sau: Sử dụng ít nhất 8 ký tự, bao gồm chữ hoa, chữ thường và số."></p-message>
    <div class="p-fluid p-formgrid p-grid p-mt-2">
      <div class="p-field p-col-12">
        <label for="oldPassword">{{ 'Password'|translate }}<span class="required">*</span></label>
        <p-password id="oldPassword" formControlName="oldPassword" [toggleMask]="true" [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('oldPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPassword">{{ 'NewPassword'|translate }}<span class="required">*</span></label>
        <p-password id="newPassword" formControlName="newPassword" [toggleMask]="true" [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('newPassword')"></app-validator>
      </div>
      <div class="p-field p-col-12">
        <label for="newPasswordVerify">{{ 'NewPasswordVerify'|translate }}<span class="required">*</span></label>
        <p-password id="newPasswordVerify" formControlName="newPasswordVerify" [toggleMask]="true"
          [feedback]="false"></p-password>
        <app-validator [control]="changePasswordForm.get('newPasswordVerify')"></app-validator>
      </div>
    </div>
    <p-message severity="error" [text]="changePasswordError" *ngIf="changePasswordError"></p-message>
    <p-footer>
      <p-button label="{{ 'ChangePassword'|translate }}" icon="pi pi-check" styleClass="p-button-raised" type="submit"
        [disabled]="changePasswordForm.invalid"></p-button>
      <p-button label="{{ 'Close'|translate }}" icon="pi pi-times"
        styleClass="p-button-raised p-button-text p-button-plain" (onClick)="changingPassword=false"></p-button>
    </p-footer>
  </p-dialog>
</form>

<!-- App Download QR Modal -->
<div id="appDownloadQrModal" class="modal" [ngClass]="{'show': appDownloadQrVisible}">
  <div class="w-full max-w-xl bg-white rounded-3xl shadow-2xl overflow-hidden" style="width: 100%; max-width: 28rem;">
    <div
      style="padding: 1.25rem; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center;">
      <div style="text-align: left;">
        <div style="font-size: 1.25rem; font-weight: bold; color: #1e293b;">{{ currentAppDownload.title }}</div>
        <div style="font-size: 0.875rem; color: #64748b; margin-top: 0.25rem;">{{ currentAppDownload.subtitle }}</div>
      </div>
      <button type="button" (click)="closeAppDownloadQr()"
        style="width: 2.25rem; height: 2.25rem; border-radius: 0.75rem; border: none; background: transparent; cursor: pointer; color: #64748b;"><i
          class="fa-solid fa-xmark text-lg"></i></button>
    </div>
    <div style="padding: 1.5rem; text-align: center;">
      <img [src]="currentAppDownload.qrImage" [alt]="currentAppDownload.title"
        style="width: 14rem; max-width: 100%; height: auto; border-radius: 1rem; border: 1px solid #e2e8f0; padding: 0.75rem; background: #fff;">
    </div>
    <div
      style="padding: 1.25rem; border-top: 1px solid #f1f5f9; display: flex; justify-content: flex-end; gap: 0.75rem;">
      <button type="button" (click)="closeAppDownloadQr()"
        style="padding: 0.625rem 1.25rem; border-radius: 0.75rem; border: 1px solid #e2e8f0; background: #fff; cursor: pointer; font-weight: 600; color: #475569;">Đóng</button>
      <button type="button" (click)="openAppDownloadLink()"
        style="padding: 0.625rem 1.25rem; border-radius: 0.75rem; border: none; background-color: #2563eb; color: #fff; cursor: pointer; font-weight: 600;">Mở
        link tải</button>
    </div>
  </div>
</div>

<!-- Remote Support Modal -->
<div id="remoteModal" class="modal" [ngClass]="{'show': remoteModalVisible}">
  <div class="w-full max-w-xl bg-white rounded-3xl shadow-2xl overflow-hidden" style="width: 100%; max-width: 36rem;">
    <div class="flex items-center gap-3"
      style="background: linear-gradient(to right, #2563eb, #22c55e); color: white; padding: 1.25rem;">
      <div class="flex items-center justify-center"
        style="width: 3rem; height: 3rem; background-color: rgba(255,255,255,0.2); border-radius: 1rem;"><i
          class="fa-solid fa-desktop text-2xl"></i></div>
      <div style="text-align: left;">
        <div class="text-xl font-bold" style="font-size: 1.25rem;">Hỗ trợ từ xa</div>
        <div class="text-sm text-white/90" style="font-size: 0.875rem;">IAM Software chỉ hỗ trợ khi Quý khách xác nhận
          cho phép</div>
      </div>
    </div>

    <div style="padding: 1.5rem;">
      <div style="text-align: left;">
        <label style="display: block; font-weight: 600; margin-bottom: 0.5rem; font-size: 0.875rem; color: #334155;">Lý
          do hỗ trợ <span style="font-weight: normal; color: #94a3b8;">(không bắt buộc)</span></label>
        <textarea [(ngModel)]="supportReason" class="outline-none"
          style="width: 100%; height: 6rem; border-radius: 1rem; border: 1px solid #e2e8f0; padding: 0.75rem; box-sizing: border-box; resize: none;"
          placeholder="Ví dụ: Không ký được hóa đơn, lỗi USB Token, không phát hành được hóa đơn..."></textarea>
      </div>

      <label
        style="display: flex; gap: 0.75rem; align-items: flex-start; cursor: pointer; font-size: 0.875rem; text-align: left; margin-top: 1rem; color: #334155;">
        <input type="checkbox" style="margin-top: 0.25rem; width: 1rem; height: 1rem; accent-color: #2563eb;"
          [checked]="agreeRemote" (change)="agreeRemote = !agreeRemote">
        <span>Tôi đã đọc và đồng ý cho phép IAM Software hỗ trợ từ xa trên thiết bị của mình.
          <button type="button" (click)="openTermsModal()" class="text-blue-600 font-bold italic hover:underline"
            style="color: #2563eb; font-weight: bold; font-style: italic; background: none; border: none; padding: 0; cursor: pointer; text-decoration: underline;">Xem
            điều khoản</button>
        </span>
      </label>

      <div style="display: flex; justify-content: flex-end; gap: 0.75rem; margin-top: 1.25rem;">
        <button type="button" [disabled]="!agreeRemote" (click)="submitRemoteSupport($event)"
          style="border: none; border-radius: 0.75rem; padding: 0.625rem 1.25rem; color: #fff; cursor: pointer; display: inline-flex; align-items: center; gap: 0.5rem; font-weight: 600; transition: background-color 0.2s;"
          [style.background-color]="agreeRemote ? '#2563eb' : '#cbd5e1'">
          <i class="fa-solid fa-paper-plane" [style.color]="agreeRemote ? '#fff' : '#94a3b8'"></i>
          <span>Đồng ý và gửi</span>
        </button>
        <button type="button" (click)="closeRemoteModal()"
          style="padding: 0.625rem 1.25rem; border-radius: 0.75rem; border: 1px solid #e2e8f0; background: #fff; cursor: pointer; font-weight: 600; color: #475569;">Đóng</button>
      </div>
    </div>
  </div>
</div>

<!-- Terms Modal -->
<div id="termsModal" class="modal" [ngClass]="{'show': termsModalVisible}">
  <div class="w-full max-w-3xl bg-white rounded-3xl shadow-2xl overflow-hidden" style="width: 100%; max-width: 48rem;">
    <div
      style="padding: 1.25rem; border-bottom: 1px solid #f1f5f9; display: flex; justify-content: space-between; align-items: center;">
      <div style="text-align: left;">
        <div style="font-size: 1.25rem; font-weight: bold; color: #1e293b;">Điều khoản hỗ trợ từ xa</div>
        <div style="font-size: 0.875rem; color: #64748b; margin-top: 0.25rem;">Áp dụng khi khách hàng yêu cầu IAM
          Software hỗ trợ từ xa</div>
      </div>
      <button type="button" (click)="closeTermsModal()"
        style="width: 2.25rem; height: 2.25rem; border-radius: 0.75rem; border: none; background: transparent; cursor: pointer; color: #64748b;"><i
          class="fa-solid fa-xmark text-lg"></i></button>
    </div>
    <div class="terms-content"
      style="padding: 1.5rem; max-height: 55vh; overflow-y: auto; font-size: 0.875rem; line-height: 1.75rem; color: #334155; text-align: left;">
      <h3 style="font-size: 1.125rem; font-weight: 800; color: #0f172a; margin-bottom: 0.875rem;">ĐIỀU KHOẢN HỖ TRỢ TỪ
        XA</h3>
      <p style="margin-bottom: 0.75rem;">Nhằm hỗ trợ Quý khách xử lý sự cố, cài đặt, cấu hình và hướng dẫn sử dụng sản
        phẩm, IAM Software cung cấp dịch vụ hỗ trợ từ xa thông qua phần mềm điều khiển thiết bị từ xa.</p>
      <p style="margin-bottom: 0.75rem;">Khi nhấn <b>"Đồng ý và gửi yêu cầu hỗ trợ"</b>, Quý khách xác nhận và đồng ý
        rằng:</p>
      <ol style="margin-left: 1.25rem; list-style-type: decimal; margin-bottom: 1rem;">
        <li style="margin-bottom: 0.625rem;"><b><i>Quý khách chủ động yêu cầu IAM thực hiện hỗ trợ kỹ thuật từ xa đối
              với thiết bị của mình.</i></b></li>
        <li style="margin-bottom: 0.625rem;"><b><i>Quý khách tự nguyện cung cấp IAM Remote ID và mật khẩu kết
              nối</i></b> để nhân viên IAM có thể truy cập thiết bị phục vụ công tác hỗ trợ.</li>
        <li style="margin-bottom: 0.625rem;"><b><i>IAM chỉ thực hiện các thao tác liên quan đến sản phẩm và dịch vụ
              thuộc hệ sinh thái IAM</i></b>, bao gồm:
          <ul style="margin-left: 1.25rem; list-style-type: disc; margin-top: 0.5rem;">
            <li style="margin-bottom: 0.5rem;">Kiểm tra, xử lý lỗi phần mềm.</li>
            <li style="margin-bottom: 0.5rem;">Cài đặt, cấu hình sản phẩm và dịch vụ thuộc hệ sinh thái IAM.</li>
            <li style="margin-bottom: 0.5rem;">Hỗ trợ hướng dẫn sử dụng theo yêu cầu của Quý khách.</li>
            <li style="margin-bottom: 0.5rem;">Kiểm tra các vấn đề liên quan đến chữ ký số, hóa đơn điện tử và các dịch
              vụ liên quan.</li>
          </ul>
        </li>
        <li style="margin-bottom: 0.625rem;"><b><i>Việc hỗ trợ từ xa chỉ được thực hiện khi có sự đồng ý của Quý khách
              và Quý khách có thể chấm dứt kết nối bất kỳ lúc nào.</i></b></li>
        <li style="margin-bottom: 0.625rem;"><b><i>IAM cam kết không tự ý truy cập, sao chép, sử dụng hoặc khai thác dữ
              liệu của Quý khách ngoài phạm vi cần thiết để hỗ trợ.</i></b></li>
        <li style="margin-bottom: 0.625rem;"><b><i>Quý khách có trách nhiệm chủ động đóng hoặc ẩn các tài liệu, dữ liệu
              và thông tin không liên quan trước khi cấp quyền truy cập từ xa.</i></b></li>
        <li style="margin-bottom: 0.625rem;">IAM được phép ghi nhận các thông tin phục vụ công tác hỗ trợ, bao gồm:
          <ul style="margin-left: 1.25rem; list-style-type: disc; margin-top: 0.5rem;">
            <li style="margin-bottom: 0.5rem;">Thời gian tiếp nhận yêu cầu.</li>
            <li style="margin-bottom: 0.5rem;">Nội dung yêu cầu hỗ trợ.</li>
            <li style="margin-bottom: 0.5rem;">Thông tin thiết bị kết nối.</li>
            <li style="margin-bottom: 0.5rem;">Nhật ký xử lý và kết quả hỗ trợ.</li>
          </ul>
          Các thông tin này được sử dụng cho mục đích chăm sóc khách hàng, nâng cao chất lượng dịch vụ và giải quyết
          khiếu nại nếu có.
        </li>
        <li style="margin-bottom: 0.625rem;">IAM không chịu trách nhiệm đối với các sự cố phát sinh từ phần mềm, thiết
          bị hoặc hệ thống của bên thứ ba nằm ngoài phạm vi hỗ trợ.</li>
      </ol>
      <div
        style="background-color: #eff6ff; border: 1px solid #bfdbfe; border-radius: 1rem; padding: 1rem; margin-top: 1rem; font-weight: bold; font-style: italic; color: #1e3a8a;">
        Bằng việc nhấn nút "Đồng ý và gửi yêu cầu hỗ trợ", Quý khách xác nhận đã đọc, hiểu và đồng ý với toàn bộ nội
        dung điều khoản nêu trên.</div>
    </div>
    <div
      style="padding: 1.25rem; border-top: 1px solid #f1f5f9; display: flex; justify-content: flex-end; gap: 0.75rem;">
      <button type="button" (click)="closeTermsModal()"
        style="padding: 0.625rem 1.25rem; border-radius: 0.75rem; border: 1px solid #e2e8f0; background: #fff; cursor: pointer; font-weight: 600; color: #475569;">Đóng</button>
      <button type="button" (click)="agreeFromTerms()"
        style="padding: 0.625rem 1.25rem; border-radius: 0.75rem; border: none; background-color: #2563eb; color: #fff; cursor: pointer; font-weight: 600;">Tôi
        đồng ý</button>
    </div>
  </div>
</div>

<p-dialog header="Thông báo" [(visible)]="remoteAppNotFoundVisible" [style]="{width: '450px'}" [resizable]="false"
  position="top" [modal]="true">
  <div class="p-d-flex p-flex-column p-ai-center p-text-center p-p-3">
    <i class="pi pi-exclamation-triangle" style="font-size: 3rem; color: #f59e0b; margin-bottom: 1rem;"></i>
    <p style="font-size: 14px; line-height: 1.6; color: #475569;">
      Không tìm thấy ứng dụng hỗ trợ từ xa trên thiết bị của Quý khách. Vui lòng tải về và cài đặt trước khi tiếp tục.
    </p>
  </div>
  <p-footer>
    <p-button label="Tải phần mềm" icon="pi pi-download" styleClass="p-button-raised"
      (onClick)="downloadRemoteSupport(); remoteAppNotFoundVisible=false;"></p-button>
    <p-button label="Đóng" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain"
      (onClick)="remoteAppNotFoundVisible=false"></p-button>
  </p-footer>
</p-dialog>